import { IUpdateScript, IFieldSchema, IModelOptions } from "../interfaces";

export class DBMigration implements IUpdateScript {

    constructor(private _adaptor: IUpdateScript) { }

    private getAdaptor(): IUpdateScript {
        if (this._adaptor === null || this._adaptor === undefined) {
            throw "Adaptor is not set for the update script and will not be able to proceed";
        }
        return this._adaptor;
    }

    addColumn(model: string, key: string, options: IFieldSchema): void {
        this.getAdaptor().addColumn(model, key, options);
    }
    alterColumn(model: string, key: string, options: IFieldSchema): void {
        this.getAdaptor().alterColumn(model, key, options);
    }
    renameColumn(model: string, key: string, newKey: string): void {
        this.getAdaptor().renameColumn(model, key, newKey);
    }
    removeColumn(model: string, key: string): void {
        this.getAdaptor().removeColumn(model, key);
    }
    addTable(model: string, options: IModelOptions): void {
        this.getAdaptor().addTable(model, options);
    }
    removeTable(model: string): void {
        this.getAdaptor().removeTable(model);
    }
    renameTable(model: string, newModel: string): void {
        this.getAdaptor().renameTable(model, newModel);
    }
    alterTable(model: string, options: IModelOptions): void {
        this.getAdaptor().alterTable(model, options);
    }
}